import { AgxIdentityVerificationExports } from '@urbanx/agx.ui-components2'
import { MenuTitles, Pages } from 'constants/menu'
import {
  useFeatureToggles,
  useSelectedCampaign,
  useSelectedContract,
} from 'hooks'
import { Navigate } from 'react-router-dom'
import { ContractSubPage } from '../ContractSubPage'
import { getBuyerDetailsSubPages } from './BuyerDetailsSubPages'

const BuyerIdentityVerification = () => {
  const { campaign } = useSelectedCampaign()
  const { contract } = useSelectedContract()
  const { featureToggles, isLoading: featureTogglesLoading } =
    useFeatureToggles()
  const showIdentityVerification = featureToggles?.identityVerification === true

  if (featureTogglesLoading) return null

  if (!showIdentityVerification) {
    return <Navigate to={`../${Pages.BUYERS_INFORMATION}`} replace />
  }

  return (
    <ContractSubPage
      pageTitle="Buyer Details"
      secondaryActiveMenu={MenuTitles.BUYERS_DETAILS}
      currentPage={Pages.BUYERS_IDENTITY_VERIFICATION}
      subPages={getBuyerDetailsSubPages(
        campaign?.state,
        showIdentityVerification
      )}
      onSaveChanges={() => undefined}
      isFormDirty={false}
      isSaving={false}
      isError={false}
      hideSaveButton
    >
      <AgxIdentityVerificationExports
        id="BuyerIdentityVerificationExports"
        campaignId={campaign?.campaignId ?? ''}
        contractId={contract?.contractId ?? ''}
        mode="buyers"
      />
    </ContractSubPage>
  )
}

export default BuyerIdentityVerification
